// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { PostTradeRisk, PreTradeRisk } from '@innolab-trader/tradovate-types'

export interface OpenDemoAccount {
  templateAccountId?: number
  name?: string
  initialBalance?: number
  defaultAutoLiq?: PostTradeRisk
  preTradeRisk?: Array<PreTradeRisk>
}

export interface OpenDemoAccountResponse {
  errorText?: string
  accountId?: number
}

/**
 * Validate OpenDemoAccount request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateOpenDemoAccount(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateOpenDemoAccount(request: OpenDemoAccount): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (typeof req.name === 'string' && req.name.length > 64) {
    errors.push({
      field: 'name',
      code: 'too_long',
      message: 'name must not exceed 64 characters',
      argument: '64'
    })
  }

  return errors
}

export const openDemoAccount = postEndpoint<OpenDemoAccount, OpenDemoAccountResponse>('/user/openDemoAccount')
